import * as React from "react";
const SvgIconArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 63.6 113.2", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "56.6 0 63.6 7.1 14.2 56.6 63.6 106.1 56.6 113.2 7.1 63.7 7.1 63.7 0 56.6 7.1 49.5 7.1 49.5 56.6 0" }));
export default SvgIconArrowLeft;
